var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoUserInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 2C9.60139 2 7.65625 3.94514 7.65625 6.34459C7.65625 8.74404 9.60139 10.6892 12.0008 10.6892C14.4003 10.6892 16.3454 8.74404 16.3454 6.34459C16.3454 3.94514 14.4003 2 12.0008 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93359 12.189C6.0341 12.189 3.68359 14.5395 3.68359 17.439V18.75C3.68359 19.9926 4.69095 21 5.93359 21H11.3215C10.3398 19.8113 9.75 18.287 9.75 16.625C9.75 14.9344 10.3602 13.3863 11.3725 12.189H8.93359Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.625C11.25 13.6565 13.6565 11.25 16.625 11.25C19.5935 11.25 22 13.6565 22 16.625C22 19.5935 19.5935 22 16.625 22C13.6565 22 11.25 19.5935 11.25 16.625ZM15.824 14.4992C15.824 14.941 16.1822 15.2992 16.624 15.2992H16.634C17.0759 15.2992 17.434 14.941 17.434 14.4992C17.434 14.0574 17.0759 13.6992 16.634 13.6992H16.624C16.1822 13.6992 15.824 14.0574 15.824 14.4992ZM16.625 16.2504C16.2108 16.2504 15.875 16.5862 15.875 17.0004V18.7487C15.875 19.1629 16.2108 19.4987 16.625 19.4987C17.0392 19.4987 17.375 19.1629 17.375 18.7487V17.0004C17.375 16.5862 17.0392 16.2504 16.625 16.2504Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoUserInfo);
export default __webpack_public_path__ + "static/media/DuoUserInfo.a93e58ad4f8b12d4c036e1ccab36a5e8.svg";
export { ForwardRef as ReactComponent };